<template>
  <!-- dsio-app -->
  <div ref="appContainer">
    <!-- app-container -->
    <div>
      <header>
        <!-- dsio-header--top -->
        <div>
          <keep-alive>
            <dsio-engine
              :filters="filters"
              :displayMore="moreFilters"
              :counter="counter"
              :nbVisibleFilters="isMobileScreen && moreFilters ? 0 : nbVisibleFilters"
            />
          </keep-alive>
        </div>
        <!-- dsio-header--bottom -->
        <div>
          <div>
            <div>
              <p v-html="counter" />
            </div>
            <keep-alive>
              <dsio-sort
                :sorts="sorts"
                :sortBy="app.state.sortBy"
                :sortPrefix="t.sortPrefix"
                :sortDesc="sortDesc"
              />
            </keep-alive>
            <div v-show="app.params.userPosition">
              <keep-alive>
                <dsio-user-pos
                  v-if="app.params.userPosition"
                  :sort="sorts.proximite ? 'proximite' : null"
                />
              </keep-alive>
            </div>
            <div>
              <keep-alive>
                <dsio-context-filters />
              </keep-alive>
            </div>
            <keep-alive>
              <dsio-mods
                v-if="filters.geo"
                :viewMods="app.params.viewMods"
                :defaultViewMod="defaultViewMod"
              />
            </keep-alive>
          </div>
        </div>
      </header>
      <!-- app-body -->
      <div ref="appBody">
        <!-- list-wrapper -->
        <div
          v-show="listActive"
          class="list-wrapper lcol"
          :class="{loading, loadingMore}"
        >
          <dsio-list
            :list="list"
            :loading="loading"
          />
          <dsio-pagination
            v-if="pagination"
            :html="pagination"
          />
        </div>
        <div
          v-if="filters.geo"
          v-show="mapActive"
        >
          <div>
            <dsio-map
              v-if="mapActive"
              :id="'geo'"
              :mapItems="mapItems"
              :bounds="mapConf.keepModChangeMapState && app.state.savedMapBounds ? app.state.savedMapBounds : bounds"
              :conf="mapConf"
              @popupOpen="mapPopupOpen = true"
              @popupClose="mapPopupOpen = false"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- dsio-detail -->
    <div
      v-if="app.params.detailPopup"
      v-show="oiId"
      class="dsio-detail"
    >
      <dsio-detail
        :oiId="oiId"
        :sortedIds="sortedIds"
        :conf="staticConf.detail"
      />
    </div>
  </div>
</template>
<script>
import BaseScript from 'mixins/AppComponentBase';

export default {
  mixins: [
    BaseScript,
  ],
};
</script>
